import styled, { css, keyframes } from 'styled-components';

const focusPulse = keyframes`
  0% { box-shadow: 0 0 0 0 rgba(255, 152, 0, 0.5); }
  70% { box-shadow: 0 0 0 8px rgba(255, 152, 0, 0); }
  100% { box-shadow: 0 0 0 0 rgba(255, 152, 0, 0); }
`;

export const Container = styled.button<{ $success?: boolean }>`
  background: ${props => (props.$success ? '#4CAF50' : '#FF9800')};
  background-size: 200% auto;
  transition:
    background-color 0.3s ease,
    transform 0.2s ease,
    opacity 0.3s ease;
  color: #fff;
  font-family: 'MarkPro-Bold';
  outline: 0;
  box-shadow: 0px 3px 6px rgba(255, 152, 0, 0.3);
  position: relative;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover:not(.loading) {
    background-position: right center;
    transform: ${props => !props.$success && 'translateY(-1px)'};
  }

  &:active:not(.loading) {
    transform: translateY(1px);
  }

  &.disabled,
  &:disabled {
    background: #ffb84d;
    box-shadow: none;
    cursor: not-allowed;
    opacity: 0.75;
  }

  /* O :not() acima já cobre .loading; o botão desabilitado também não anima. */
  &:disabled:hover,
  &:disabled:active {
    transform: none;
  }

  &:focus-visible {
    outline: 2px solid transparent;
    box-shadow: 0 0 0 3px rgba(255, 152, 0, 0.4);
    animation: ${focusPulse} 1.5s infinite;
  }

  &.loading {
    cursor: not-allowed;
    opacity: 0.6;
  }

  ${props =>
    props.$success &&
    css`
      box-shadow: 0px 3px 6px rgba(76, 175, 80, 0.3);
      cursor: default;

      &:hover {
        transform: none;
      }

      // Ajuste a animação de foco para o estado de sucesso
      &:focus-visible {
        box-shadow: 0 0 0 3px rgba(76, 175, 80, 0.4);
        animation: ${focusPulse} 1.5s infinite;
      }
    `}

  > * {
    transition: opacity 0.3s ease;
  }
`;

const checkmarkAnimation = keyframes`
  0% { transform: scale(0); opacity: 0; }
  80% { transform: scale(1.2); opacity: 1; }
  100% { transform: scale(1); opacity: 1; }
`;

export const Checkmark = styled.svg`
  width: 1.4rem;
  height: 1.4rem;
  animation: ${checkmarkAnimation} 0.4s cubic-bezier(0.68, -0.55, 0.27, 1.55);
  stroke: currentColor;
  stroke-width: 3;
  stroke-linecap: round;
  stroke-linejoin: round;
  fill: none;
`;
